import React, { useMemo } from 'react'
import { connect } from 'react-redux'

import S from '../styled'

import {
  List,
  IngredientsModal,
  TranslatesModal,
} from  '../../../../components'

import IngredientDetails from './details'
import actions from './actions'
import listOptions from './listOptions'

const Ingredients = ({
  defaultLocale, locales, ingredients, servings, model: variationModel, field,
  ingredients: availableIngredients,
  regions: availableRegions,
  units: availableUnits,
  ingredientsSelector,
  appliances,
  locked,
  addToIngredientsList,
}) => {

  const { model, values, onChange, isValidPath } = variationModel

  const {
    handleTranslationChange,
    handleAddIngredientModal,
    handleAddIngredient,
    handleCategoryRename,
    handleChangeCategoryTranslate,
    showTranslatesModal,
    setShowTranslatesModal,
    showAddIngredient,
    setShowAddIngredient,
    handleSelectIngredient,
    selectedIngredient,
    handleRecalculateQuantity,
    handleDeleteIngredient,
    handleChangeOrder,
    handleAddCategory,
    handleCreateCategory,
    getConfirmDeleteText,
  } = actions({
    onChange, model, servings, field, availableUnits, ingredientsSelector, defaultLocale, appliances,
    addToIngredientsList,
  })

  const options = useMemo(() => listOptions({ defaultLocale, ingredients, isValidPath }),
    [defaultLocale, ingredients, isValidPath])
  return (
    <S.Ingreditens>
      <S.IngredientsList>
        <List
          name="sections"
          items={values && values[field] ? values[field].sections : []}
          modelPrefix={`values[${field}]`}
          subcategory="ingredients"
          hasSubchildrenField="hasReplacement"
          subchildrenField="replacements"
          options={options}
          onAdd={handleAddIngredientModal}
          onRename={handleCategoryRename}
          onSelect={handleSelectIngredient}
          selected={selectedIngredient}
          onDelete={handleDeleteIngredient}
          onChangeOrder={handleChangeOrder}
          onAddCategory={handleAddCategory}
          allowAddCategory
          allowDeleteCategory
          getConfirmDeleteText={getConfirmDeleteText(model, field, defaultLocale)}
          readOnly={locked}
        />
      </S.IngredientsList>
      <IngredientDetails {...{
        selectedIngredient,
        handleTranslationChange,
        handleRecalculateQuantity,
        ingredientModel: variationModel,
        locales,
        defaultLocale,
        servings,
        field,
        ingredients: availableIngredients,
        regions: availableRegions,
        units: availableUnits,
        locked,
      }}/>
      {
        showAddIngredient && (
          <IngredientsModal
            onClose={() => setShowAddIngredient(null)}
            onChange={handleAddIngredient}
            filter={showAddIngredient.ingredients || []}
            fullWidth
          />
        )
      }
      {
        showTranslatesModal && (
          <TranslatesModal
            translates={showTranslatesModal.translates}
            locales={locales}
            defaultLocale={defaultLocale}
            onClose={() => setShowTranslatesModal(null)}
            onChange={showTranslatesModal.new ? handleCreateCategory : handleChangeCategoryTranslate}
          />
        )
      }
    </S.Ingreditens>
  )
}

const mapStateToProps = (state, { entityName }) => ({
  regions: state.regions.list,
  ingredients: state.recipes.ingredients,
  units: state.units.list,
})

const mapDispatchToProps = dispatch => ({
  addToIngredientsList: ingredients => dispatch({
    type: 'addIngredientToRecipe',
    payload: ingredients,
  }),
})

export default connect(mapStateToProps, mapDispatchToProps)(Ingredients)
